import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ppbnrs-modal" }
const _hoisted_2 = { class: "ppbnrs-modal__content" }
const _hoisted_3 = { class: "ppbnrs-modal__banners" }
const _hoisted_4 = { class: "ppbnrs-banner" }
const _hoisted_5 = { class: "ppbnrs-banner__title" }
const _hoisted_6 = { class: "ppbnrs-banner" }
const _hoisted_7 = { class: "ppbnrs-banner__title" }

import { computed, watch } from "vue";
import "@/../../css/widgets/popup-banners/popup-banners.scss";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { StringHelper } from "@/helpers/string-helper";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";


export default /*@__PURE__*/_defineComponent({
  __name: 'popup-banners',
  props: {
    popupBannersModalVisible: { type: Boolean },
    jackpotSportka: {},
    jackpotEurojackpot: {}
  },
  emits: ["close-popup-banners-modal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const jackpotSportkaTitle = computed(() => {
    return props.jackpotSportka > 0 ? `${StringHelper.toCurrencyString(props.jackpotSportka)}` : "milionové výhry";
});
const jackpotEurojackpotTitle = computed(() => {
    return props.jackpotEurojackpot > 0
        ? `${StringHelper.toCurrencyString(props.jackpotEurojackpot)}`
        : "miliardové výhry";
});

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
watch(
    () => props.popupBannersModalVisible,
    (newOpened) => {
        if (newOpened) {
            addToStackedModals();
        } else {
            removeFromStackedModals();
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransitionFade, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "ppbnrs-modal__background",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close-popup-banners-modal')))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "ppbnrs-modal__close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close-popup-banners-modal'))),
            "aria-label": "Zavřít"
          }),
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "ppbnrs-modal__title" }, "Zvyšte svou šanci na výhru ✌️.", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/homepage/sportka-banner-bg.jpg",
                cssClass: "ppbnrs-banner__bg",
                alt: "Sportka - obrázek na pozadí"
              }),
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/tickets/sportka-dark.png",
                cssClass: "ppbnrs-banner__logo",
                alt: "Sportka - logo"
              }),
              _createElementVNode("h3", _hoisted_5, [
                _cache[2] || (_cache[2] = _createTextVNode("Hrajte o ")),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(jackpotSportkaTitle.value), 1)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("a", {
                href: "/loterie/sportka/sazky-a-vysledky",
                class: "btn btn-secondary"
              }, " Více o loterii sportka ", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/homepage/eurojackpot-banner-bg.jpg",
                cssClass: "ppbnrs-banner__bg",
                alt: "Sportka - obrázek na pozadí"
              }),
              _createVNode(WebpImage, {
                src: "/frontend/kasa-loyalty/img/tickets/eurojackpot.png",
                cssClass: "ppbnrs-banner__logo",
                alt: "Sportka - logo"
              }),
              _createElementVNode("h3", _hoisted_7, [
                _cache[5] || (_cache[5] = _createTextVNode("Hrajte o ")),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(jackpotEurojackpotTitle.value), 1)
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("a", {
                href: "/loterie/eurojackpot/sazky-a-vysledky",
                class: "btn btn-secondary"
              }, " Více o loterii eurojackpot ", -1))
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ppbnrs-modal__note" }, " Při každém svém nákupu loterie nebo losu použijte Sazka kartu. Následující den si zatočíte Kolem štěstí a získáte svou extra šanci na výhru. ", -1))
        ])
      ], 512), [
        [_vShow, props.popupBannersModalVisible]
      ])
    ]),
    _: 1
  }))
}
}

})